import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { statusOptions } from '../../../utils/mics';
import { Tree } from 'primereact/tree';
import { sideMenuItems } from '../../../components/Sidebar';
import PermissionsTree from './RolePermissionsTree';

const RolesDialog = ({ visible, onHide, role, onSave, isAddNew }) => {

    const [formData, setFormData] = useState(role || {});
    const [isFormValid, setIsFormValid] = useState(false);
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const isViewMode = role?.isView || false;

    useEffect(() => {
        if (visible) {
            setFormData(role || {});
            setErrors({});
            setTouched({});
            setIsFormValid(true);
        }
    }, [role, visible]);

    const validateForm = (data) => {
        const newErrors = {};
        let isValid = true;

        if (!data.name) {
            newErrors.name = 'Name is required';
            isValid = false;
        }
        if (!data.code) {
            newErrors.code = 'Code is required';
            isValid = false;
        }

        if (!data.permissions || data.permissions.length === 0) {
            newErrors.permissions = 'Permissions are required';
            isValid = false;
        }

        setErrors(newErrors);
        setIsFormValid(isValid);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const updatedData = {
            ...formData,
            [name]: value,
        };
        debugger
        setFormData(updatedData);
        validateForm(updatedData);
    };

    const handleFieldBlur = (e) => {
        const { name } = e.target;
        setTouched((prevTouched) => ({
            ...prevTouched,
            [name]: true,
        }));
    };

    const handleSave = () => {

        setTouched({
            name: true,
            code: true,
            status: true,
        });
        
        validateForm(formData);

        if (isFormValid) {
            onSave(formData);
            onHide(); 
            setFormData({});
            setErrors({});
            setTouched({});
            setIsFormValid(true);
        }

    };

    return (
        <Dialog style={{ width: '80vw' }} visible={visible} header={isViewMode ? "View Role" :  isAddNew ? "Add New Role" : "Update Role"} modal onHide={onHide} footer={
            <div>
                <Button label="Close" icon="pi pi-times" onClick={onHide} className="p-button-text" />
                {!isViewMode && (
                    <Button label="Save" icon="pi pi-check" onClick={handleSave} autoFocus disabled={!isFormValid} />
                )}
            </div>
        }>
            <div className="p-fluid formgrid grid w-full">
                <div className="field col-12 md:col-4">
                    <label htmlFor="name" className='required'>Name</label>
                    <InputText id="name" name="name" value={formData.name || ''} onChange={handleInputChange} onBlur={handleFieldBlur} readOnly={isViewMode}  className={touched.name && errors.name ? 'p-invalid' : ''} />
                    {touched.name && errors.name && <small className="p-error">{errors.name}</small>}
                </div>
                <div className="field  col-12 md:col-4">
                    <label htmlFor="code"  className='required'>Code</label>
                    <InputText id="code" name="code" value={formData.code || ''} onChange={handleInputChange} onBlur={handleFieldBlur} readOnly={isViewMode} className={touched.code && errors.code ? 'p-invalid' : ''} />
                    {touched.code && errors.code && <small className="p-error">{errors.code}</small>}
                </div>
                <div className="field  col-12 md:col-4">
                    <label htmlFor="status"  className='required'>Status</label>
                    <Dropdown filter showClear 
                        value={formData.status || null}
                        onChange={handleInputChange}
                        onBlur={handleFieldBlur}
                        readOnly={isViewMode}
                        options={statusOptions}
                        id="status"
                        name="status"
                        optionLabel="name"
                        optionValue="name"
                        disabled={isViewMode}
                        placeholder="Select status"
                        className={touched.status && errors.status ? 'p-invalid' : ''}
                    />
                    {touched.status && errors.status && <small className="p-error">{errors.status}</small>}
                </div>
                <div className="field  col-12 md:col-12">
                    <PermissionsTree
                        initialPermissions={role?.permissions || []}
                        isViewMode={isViewMode}
                        onPermissionsChange={(updatedPermissions) => {
                            setFormData(prev => ({
                                ...prev,
                                permissions: updatedPermissions
                            }));
                        }}
                    />
                </div>

            </div>
        </Dialog>
    );
};

export default RolesDialog;
